/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ThresholdsValueApiModel } from './thresholds-value';

export interface RefferalProgramLevelApiModel {
  /**
   * Level number`
   */
  level?: number;
  /**
   * Reward value (optional, if value_depends_type is \'none\')
   */
  value?: number | null;
  /**
   * Values set based on thresholds
   */
  value_depends_matrix?: Array<ThresholdsValueApiModel>;
  /**
   * Reward value depends on
   */
  value_depends_type?: RefferalProgramLevelApiModelValueDependsTypeEnum | null;
}
export enum RefferalProgramLevelApiModelValueDependsTypeEnum {
  None = 'none',
  LevelReferralsNumber = 'level-referrals-number',
  LevelReferralsSaleNumber = 'level-referrals-sale-number'
}
